import none from "./none.js";

export default function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
  }
  none(series, order);
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-shape/src/offset/expand.js
// module id = 1216
// module chunks = 0